import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../assets/images/icon/icon1.png'; // Comex
import img2 from '../../assets/images/icon/icon2.png'; // Smart Signal
import img3 from '../../assets/images/icon/icon3.png'; // PipVault
import img4 from '../../assets/images/icon/icon4.png'; // RiskShield

const dataFeature = [
    {
        id: 1,
        icon: img1,
        title: 'Comex Smart Trading',
        desc: 'Automated gold/silver trades with 75–80% accuracy and 14–15 signals monthly.'
    },
    {
        id: 2,
        icon: img2,
        title: 'Smart Signal Suite',
        desc: 'AI-powered signals with 85–90% accuracy, delivered 2–3 times daily across devices.'
    },
    {
        id: 3,
        icon: img3,
        title: 'PipVault Execution',
        desc: 'Ultra-low latency, optimized routing, real-time connectivity & slippage protection.'
    },
    {
        id: 4,
        icon: img4,
        title: 'RiskShield Manager',
        desc: 'Profit-sharing with capital protection, auto stop-loss, and performance reports.'
    }
];

function Project() {
    return (
        <section className="project">
            <div className="container">
                <div className="block-text center">
                    <h6 className="sub-heading"><span>Our Services</span></h6>
                    <h3 className="heading">What PipPlus Tech Offers</h3>
                </div>

                <div className="row">
                    {dataFeature.map((item) => (
                        <div key={item.id} className="col-xl-3 col-md-6">
                            <div className="project-box">
                                <div className="icon">
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <h5>{item.title}</h5>
                                <p>{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* ✅ Central "More Info" Button */}
                <div style={{ textAlign: "center", marginTop: "1px" }}>
  <Link to="/services" className="action-btn">
    <span>More Info</span>
  </Link>
</div>
            </div>
        </section>
    );
}

export default Project;
